import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UserService } from "./user.service";
import { BaseEntityService } from "./rest-common.service";
import {
  DataCommission,
  SystemCommission,
  Transaction,
  adspCommission,
  bdspCommission,
  AdServiceFee,
  tdspCommission,
  Commission,
} from "src/app/models/user";
import { Observable } from "rxjs";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class AgencyService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/agency/`;

  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  addCredit(credit: Transaction, id) {
    let url = `${this.resource_url}${id}/credit/`;
    return this.post(url, credit);
  }

  addDebit(debit: Transaction, id) {
    let url = `${this.resource_url}${id}/debit/`;
    return this.post(url, debit);
  }

  getBalance(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/balance/`, "", params);
    return this.get(url);
  }

  getAccountStatement(id, params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}${id}/account-statement/`,
      "",
      params
    );
    return this.get(url);
  }

  getInvoiceStatement(id, params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}${id}/account-invoice/`,
      "",
      params
    );
    return this.get(url);
  }

  getOfflineCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/vdsp-oc/`, "", params);
    return this.get(url);
  }

  setOfflineCommission(id, commission) {
    let url = `${this.resource_url}${id}/vdsp-oc/`;
    return this.put(url, commission);
  }

  getSystemCommission(id) {
    let url = `${this.resource_url}${id}/sc/`;
    return this.get(url);
  }

  getCommissionHistory(id) {
    let url = `${this.resource_url}${id}/commission-history/`;
    return this.get(url);
  }

  setSystemCommission(id, commission: SystemCommission) {
    let url = `${this.resource_url}${id}/sc/`;
    return this.put(url, commission);
  }

  getDataCommission(id) {
    let url = `${this.resource_url}${id}/dc/`;
    return this.get(url);
  }

  setDataCommission(id, commission: DataCommission) {
    let url = `${this.resource_url}${id}/dc/`;
    return this.put(url, commission);
  }

  getAdspSystemCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-sc/`, "", params);
    return this.get(url);
  }

  setAdspSystemCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-sc/`;
    return this.put(url, commission);
  }

  getAdspDataCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-dc/`, "", params);
    return this.get(url);
  }

  setAdspDataCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-dc/`;
    return this.put(url, commission);
  }

  getAdspContractCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-cc/`, "", params);
    return this.get(url);
  }

  setAdspContractCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-cc/`;
    return this.put(url, commission);
  }

  getPrivateDealCommission(id) {
    let url = `${this.resource_url}${id}/vdsp-cdc/`;
    return this.get(url);
  }

  setPrivateDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/vdsp-cdc/`;
    return this.put(url, commission);
  }

  getRegularDealCommission(id) {
    let url = `${this.resource_url}${id}/vdsp-sdc/`;
    return this.get(url);
  }

  setRegularDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/vdsp-sdc/`;
    return this.put(url, commission);
  }

  getAdspDealCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-dlc/`, "", params);
    return this.get(url);
  }

  setAdspDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-dlc/`;
    return this.put(url, commission);
  }

  getBdspContractCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-cc/`;
    return this.get(url);
  }

  setBdspContractCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-cc/`;
    return this.put(url, commission);
  }

  getBdspSystemCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-sc/`;
    return this.get(url);
  }

  setBdspSystemCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-sc/`;
    return this.put(url, commission);
  }

  getBdspDataCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-dc/`;
    return this.get(url);
  }

  setBdspDataCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-dc/`;
    return this.put(url, commission);
  }

  getBdspContractDealCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-cdc/`;
    return this.get(url);
  }

  setBdspContractDealCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-cdc/`;
    return this.put(url, commission);
  }

  getBdspSystemDealCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-sdc/`;
    return this.get(url);
  }

  setBdspSystemDealCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-sdc/`;
    return this.put(url, commission);
  }

  getBdspAgencyCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-agency-comm/`
    return this.get(url);
  }

  setBdspAgencyCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-agency-comm/`
    return this.put(url, commission);
  }

  getTdspContractCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-cc/`;
    return this.get(url);
  }

  setTdspContractCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-cc/`;
    return this.put(url, commission);
  }

  getTdspSystemCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-sc/`;
    return this.get(url);
  }

  setTdspSystemCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-sc/`;
    return this.put(url, commission);
  }

  getTdspDataCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-dc/`;
    return this.get(url);
  }

  setTdspDataCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-dc/`;
    return this.put(url, commission);
  }

  getTdspContractDealCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-cdc/`;
    return this.get(url);
  }

  setTdspContractDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-cdc/`;
    return this.put(url, commission);
  }

  getTdspSystemDealCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-sdc/`;
    return this.get(url);
  }

  setTdspSystemDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-sdc/`;
    return this.put(url, commission);
  }

  getTdspAgencyCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-agency-comm/`
    return this.get(url);
  }

  setTdspAgencyCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-agency-comm/`
    return this.put(url, commission);
  }

  uploadRegistrationForm(data, params = {}): Observable<any> {
    let url = `${this.BASE_API_URL}/file-records/upload/`;
    return this.post(url, data);
  }

  getAdServiceFee(id, type: string, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/${type}/`, "", params);
    return this.get(url);
  }
  setAdServiceFee(id, type: string, adServiceFee: AdServiceFee, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/${type}/`, "", params);
    return this.put(url, adServiceFee);
  }
}

@Injectable({
  providedIn: "root",
})
export class AgencyUserService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/agency/users/`;

  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  associateAgencyUsers(id, agency_advertisers, params = {}) {
    let data = {
      agency_advertisers: agency_advertisers,
    };
    let url = this.buildUrl(`${this.resource_url}${id}/associate/`, "", params);
    return this.put(url, data);
  }

  updateLicense(data, params) {
    let url = this.buildUrl(`${this.resource_url}qlik-access/`, "", params);
    return this.put(url, data);
  }

  getUserClickAccess(params) {
    let url = this.buildUrl(`${this.resource_url}qlik-access/`, "", params);
    return this.get(url);
  }
}

@Injectable({
  providedIn: "root",
})
export class AgencyAdvertiserService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/agency-advertiser/`;

  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }
}

@Injectable({ providedIn: "root" })
export class AgencyHelperService {
  constructor() { }

  prepareAgency(agency: any): any {
    if (!agency.apnx_enabled) {
      agency.apnx_commission = new Commission();
    }

    delete agency.config?.override_msa_check;

    if (!agency.adsp_enabled) {
      agency.adsp_regions = null;
      agency.adsp_target_countries = null;
    }

    if (!agency.tdsp_enabled) {
      agency.tdsp_details = null;
    }

    if (
      (agency.adsp_enabled || agency.bdsp_enabled || agency.tdsp_enabled) &&
      !agency.apnx_enabled
    ) {
      agency.apnx_commission.contract_commission = 0;
    }

    return agency;
  }
}

@Injectable({ providedIn: "root" })
export class AgnAdvHelperService {
  targetingEU: boolean = false;
  isAdvPayer: boolean = false;

  constructor() { }

  prepareTDSPAgnAdv(agencyAdvertiser: any): any {
    agencyAdvertiser.adsp_details = null;
    agencyAdvertiser.bdsp_category = null;
    this.targetingEU = agencyAdvertiser.tdsp_details.targetingEU;
    this.isAdvPayer = agencyAdvertiser.tdsp_details.isAdvPayer;

    delete agencyAdvertiser.tdsp_details.targetingEU;
    delete agencyAdvertiser.tdsp_details.isAdvPayer;

    if (!this.targetingEU) {
      agencyAdvertiser.tdsp_details.eu_advertiser_name = null;
      agencyAdvertiser.tdsp_details.payer_name = null;
    }
    if (this.isAdvPayer) {
      agencyAdvertiser.tdsp_details.payer_name = null;
    }

    return agencyAdvertiser;
  }

  restoreTdsp(agencyAdvertiser: any) {
    if (agencyAdvertiser?.tdsp_details) {
      agencyAdvertiser.tdsp_details.targetingEU = this.targetingEU;
      agencyAdvertiser.tdsp_details.isAdvPayer = this.isAdvPayer;
    }
  }
}
